(ns frontend.actions.guest
  (:require [frontend.conn :as conn]
            [promesa.core :as p]))

(defn *->revoke! [data on-success! on-error!]
  (-> (conn/sendp! :guest/revoke
                   data)
      (p/then on-success!)
      (p/catch on-error!)))
